import React, {FC} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import styles from './Sent.css';

export const Sent: FC = () => {
	const t = useLocalizer();

	return (
		<div className={styles.root}>
			<p className={styles.title}>{t('sentTitle')}</p>
			<p className={styles.subtitle}>{t('sentInfo')}</p>
		</div>
	);
};

Sent.displayName = 'Sent';
